import { ReactSVG } from "react-svg";
import { useProfileStore } from "../../store/useUserStore";

const ProgressLoader = () => {
  const { progressActive, progressValue } = useProfileStore();
  if (!progressActive) return null;
  return (
    <div className="fixed inset-0 z-[999999] flex flex-col items-center justify-center bg-white">
      <ReactSVG
        src={process.env.PUBLIC_URL + "/assets/img/mykoku-kitten-loading.svg"}
        beforeInjection={(svg) => {
          svg.setAttribute("width", "200");
          svg.setAttribute("height", "105");
        }}
        className="mb-4"
      />
      <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-theme rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progressValue}%` }}
        />
      </div>
      <span className="mt-3 text-sm font-medium text-gray-700">{progressValue}%</span>
    </div>
  );
};

export default ProgressLoader;
